import { Box, Button, Paper, TextField, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText, Card, FormControl, FormHelperText } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import configSiteUrls from '../../../configs/configSiteUrls';

import { useAddOuvidoriaRespostaMutation, useGetOuvidoriaByLoginMutation, useGetOuvidoriaQuery } from '../ouvidoriaApiSlice';
import { ISouvidoria, ISouvidoriaList, OuvidoriaList, OuvidoriaRespostaDTO } from '../types/Ouvidoria';
import { Iso } from '@mui/icons-material';
import { OuvidoriaAnexo } from '../types/OuvidoriaAnexo';
import { useAddOuvidoriaAnexosRespostaMutation, useGetOuvidoriaAnexosQuery, useGetOuvidoriaAnexosRespostaQuery, useRemoveOuvidoriaAnexoExcluidoMutation } from '../ouvidoriaAnexoApiSlice';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import GeralAnexosUpload from '../../licitacao/create/GeralAnexosUpload';
import DownloadAnexoButton from '../../noticia/create/DownloadAnexoButton';
import convertImageToWeb from '../../../../../utils/convertImageToWeb';
import errorFormat from '../../../../../utils/errorFormat';
import { OuvidoriaEditHistorico } from './OuvidoriaEditHistorico';

export const OuvidoriaEdit = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [dados, setDados] = useState<OuvidoriaList>(ISouvidoriaList);
  const [resposta, setResposta] = useState<string>('');

  //verificar se for edicao ele pega o id e faz a consulta
  const id = useParams().id || '';
  const { data, isFetching, error } = useGetOuvidoriaQuery(id);
  useEffect(() => {
    if (data) {
      setDados(data as OuvidoriaList);
      setResposta((data as OuvidoriaList).resposta || '');
    }
  }, [data, error, isFetching]);

  const [createOuvidoriaResposta, status] = useAddOuvidoriaRespostaMutation();
  const [createAnexosResposta, statusCreateAnexosResposta] = useAddOuvidoriaAnexosRespostaMutation();
  const [removeAnexosExcluidos, statusRemoveExcluido] = useRemoveOuvidoriaAnexoExcluidoMutation();

  const [ouvidoriaAnexoParaSalvar, setOuvidoriaAnexoParaSalvar] = useState<File[]>([]);
  const [ouvidoriaAnexoSalvo, setOuvidoriaAnexoSalvo] = useState<OuvidoriaAnexo[] | null>(null);

  const [ouvidoriaAnexoParaSalvarResposta, setOuvidoriaAnexoParaSalvarResposta] = useState<File[]>([]);
  const [ouvidoriaAnexoSalvoResposta, setOuvidoriaAnexoSalvoResposta] = useState<OuvidoriaAnexo[] | null>(null);

  const handleFileAnexoChange = async (files: File[]) => {
    const convertedFiles = await Promise.all(files.map(file => convertImageToWeb(file)));
    setOuvidoriaAnexoParaSalvarResposta(prev => [...prev, ...convertedFiles]);
  };
  const handleOnDeleteParaSalvarResposta = (index: number) => {
    setOuvidoriaAnexoParaSalvarResposta(prev => prev.filter((_, i) => i !== index));
  };
  const handleExcluirTodosAnexos = () => {
    setOuvidoriaAnexoParaSalvarResposta([]);
  };

  function handleOnDeleteSalvo(fileId: string) {
    setOuvidoriaAnexoSalvoResposta(prev => {
      if (prev) {
        return prev.map(arq => (arq.id === fileId ? { ...arq, excluido: true } : arq));
      }
      return null; // ou um array vazio se preferir
    });
  }

  const { data: dataAnexo, isLoading: isLoadingAnexo } = useGetOuvidoriaAnexosQuery({ idOuvidoriaAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexo) {
      setOuvidoriaAnexoSalvo(dataAnexo);
    }
  }, [dataAnexo]);

  const { data: dataAnexoResposta, isLoading: isLoadingAnexoResposta } = useGetOuvidoriaAnexosRespostaQuery({ idOuvidoriaAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexoResposta) {
      setOuvidoriaAnexoSalvoResposta(dataAnexoResposta);
    }
  }, [dataAnexoResposta]);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!resposta || resposta.trim() === '') {
      enqueueSnackbar('O campo Resposta é obrigatório.', { variant: 'warning' });
      return;
    }

    const parms: OuvidoriaRespostaDTO = {
      id: dados.id || '',
      resposta: resposta.trim()
    };

    setLoading(true);
    const result: any = await createOuvidoriaResposta(parms);
    const dataOuvidoria = result?.data;
    const idOuvidoria = dataOuvidoria?.id;

    if (idOuvidoria) {
      if (ouvidoriaAnexoParaSalvarResposta.length) {
        const formData = new FormData();
        ouvidoriaAnexoParaSalvarResposta.forEach(file => formData.append('imagens', file));
        formData.append('ouvidoriaID', idOuvidoria);
        createAnexosResposta(formData);
      }

      if (ouvidoriaAnexoSalvoResposta && ouvidoriaAnexoSalvoResposta?.length) {
        let ouvidoriaAnexoSalvoExcluido: { idAnexo: string }[];

        ouvidoriaAnexoSalvoExcluido = ouvidoriaAnexoSalvoResposta.filter(it => it.excluido === true).map(it => ({ idAnexo: it.id }));

        if (ouvidoriaAnexoSalvoExcluido.length) {
          const formData = new FormData();
          formData.append('ouvidoriaID', idOuvidoria);
          formData.append('anexosExcluidos', JSON.stringify(ouvidoriaAnexoSalvoExcluido));
          removeAnexosExcluidos(formData);
        }
      }

      handleExcluirTodosAnexos();
      //navigate(configSiteUrls.SITE_OUVIDORIA_T);
    }
    setLoading(false);
  }
  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      // navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  return (
    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
      
      <Paper
        sx={{
          width: '100%',
          p: 3,
          mx: 'auto',
          maxWidth: {
            xs: '100%', // celular
            sm: '600px', // tablets
            md: '800px', // telas médias
            lg: '1000px', // telas grandes
            xl: '1200px' // monitores muito grandes
          }
        }}
      >
        {!dados.id ? (
          <>
            <Typography variant="body1" sx={{ mb: 2 }}>
              A solicitação que você está tentando acessar não foi encontrada. Verifique se o link está correto ou entre em contato com o suporte para obter assistência.
            </Typography>
          </>
        ) : (
          <>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 3
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  Dados da Solicitação
                </Typography>

                <Button variant="outlined" onClick={() => navigate(configSiteUrls.SITE_OUVIDORIA_LIST)}>
                  Voltar
                </Button>
              </Box>
            </Grid>

            <Card
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 3,
                bgcolor: '#fafafa',
                mb: 3
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Nome
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {dados.nome || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Documento
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {dados.documento || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      E-mail
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {dados.email || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Telefone
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {dados.telefone || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Categoria
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {dados.categoria || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Observação
                    </Typography>
                    <Typography variant="body1" fontWeight="500" sx={{ whiteSpace: 'pre-line' }}>
                      {dados.observacao || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              {ouvidoriaAnexoSalvo && ouvidoriaAnexoSalvo.length > 0 && (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box>
                      <Accordion defaultExpanded={false}>
                        <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                          <Typography color="secondary" variant="body1" gutterBottom>
                            Anexos
                          </Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                          <Paper>
                            {!isLoadingAnexo && (
                              <>
                                <List dense>
                                  {ouvidoriaAnexoSalvo.map((file: OuvidoriaAnexo) => (
                                    <ListItem key={file.path} disablePadding secondaryAction={<DownloadAnexoButton tipo="OUVIDORIA" ida={file.path} fileName={file.nomeOriginal} />}>
                                      <ListItemText
                                        primary={file.nomeOriginal}
                                        primaryTypographyProps={{
                                          variant: 'body2',
                                          color: 'secondary'
                                        }}
                                      />
                                    </ListItem>
                                  ))}
                                </List>
                              </>
                            )}
                          </Paper>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Card>
          </>
        )}

        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Dados dos Andamentos
        </Typography>
        <OuvidoriaEditHistorico dados={dados} id={id} />
      </Paper>
    </Box>
  );
};
